// extracted by mini-css-extract-plugin
export default {"popup":"QGI8j","visible":"H-jqc","fade-in":"j5KFc","fadeIn":"j5KFc","editor":"ySOd1","relativeContainer":"GETqS","content":"Qk6fb","triangle":"OJZhz","left":"_2M9VG","right":"hNtEy"};